export function htmlEncode(stringToEncode) {
    return { __html: stringToEncode };
}

export function htmlDecode(input: string) : string {
    var e = document.createElement('textarea');
    e.innerHTML = input;
    // handle case of empty input
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}